// API Configuration for different environments

const getApiBaseUrl = () => {
  const environment = import.meta.env.VITE_ENVIRONMENT || 'development'
  
  switch (environment) {
    case 'production':
      return import.meta.env.VITE_API_BASE_URL_PROD || 'https://english-teacher-ai-worker-production.cosycom21.workers.dev/api'
    case 'staging':
      return import.meta.env.VITE_API_BASE_URL_STAGING || 'https://english-teacher-ai-worker-staging.cosycom21.workers.dev/api'
    case 'development':
    default:
      return import.meta.env.VITE_API_BASE_URL_DEV || 'http://localhost:8787/api'
  }
}

export const API_BASE_URL = getApiBaseUrl()

// API endpoints
export const API_ENDPOINTS = {
  // Health check
  HEALTH: '/health',
  
  // Teacher endpoints
  TEACHER: {
    ASSESS_LEVEL: '/teacher/assess-level',
    ASSESS_LEVEL_STREAM: '/teacher/assess-level/stream',
    GRAMMAR: '/teacher/grammar',
    GRAMMAR_STREAM: '/teacher/grammar/stream',
    CONVERSATION: '/teacher/conversation',
    CONVERSATION_STREAM: '/teacher/conversation/stream',
    WRITING: '/teacher/writing',
    WRITING_STREAM: '/teacher/writing/stream',
    VOCABULARY: '/teacher/vocabulary',
    VOCABULARY_STREAM: '/teacher/vocabulary/stream',
    EXERCISES: '/teacher/exercises',
    EXERCISES_STREAM: '/teacher/exercises/stream'
  },
  // Assessment endpoints
  ASSESSMENT: {
    WRITING_TASK1: '/assessment/ielts-writing-task1',
    WRITING_TASK2: '/assessment/ielts-writing-task2',
    SPEAKING: '/assessment/ielts-speaking',
    READING: '/assessment/ielts-reading',
    LISTENING: '/assessment/ielts-listening',
    GENERAL: '/assessment/general',
    // Streaming endpoints
    WRITING_TASK1_STREAM: '/assessment/ielts-writing-task1/stream',
    WRITING_TASK2_STREAM: '/assessment/ielts-writing-task2/stream',
    SPEAKING_STREAM: '/assessment/ielts-speaking/stream',
    READING_STREAM: '/assessment/ielts-reading/stream',
    LISTENING_STREAM: '/assessment/ielts-listening/stream',
    GENERAL_STREAM: '/assessment/general/stream'
  }
}

// Helper function to build full API URL
export const buildApiUrl = (endpoint) => {
  return `${API_BASE_URL}${endpoint}`
}

// Axios instance with base configuration
import axios from 'axios'

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// Request interceptor
apiClient.interceptors.request.use(
  (config) => {
    console.log(`API Request: ${config.method?.toUpperCase()} ${config.url}`)
    return config
  },
  (error) => {
    console.error('API Request Error:', error)
    return Promise.reject(error)
  }
)

// Response interceptor
apiClient.interceptors.response.use(
  (response) => {
    console.log(`API Response: ${response.status} ${response.config.url}`)
    return response
  },
  (error) => {
    console.error('API Response Error:', error.response?.status, error.response?.data)
    return Promise.reject(error)
  }
)

export default apiClient